import React from "react"

type ResultItemProps = {
  title: string
  path: string
  index: number
}

export const ResultItem = ({ title, path, index }: ResultItemProps) => {
  return (
    <li className="dropdown-item" role="option" id={`suggestion-${index}`}>
      <a href={path} className="flex">
        {title}
      </a>
    </li>
  )
}
